export default {
    /* 默认图片 */
    defaultImg: function() {
        let baseimg = "/static/images/lifetalk512.png";
        return baseimg;
    },

    /* 判断是否为微信 */
    isWeChat: function() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    },

    /* 判断是否为Android */
    isAndroid: function() {
        if (/(Android)/i.test(navigator.userAgent)) {
            return true;
        } else {
            return false;
        };
    },

    /* 判断访问终端 */
    device: function() {
        var u = navigator.userAgent,
            app = navigator.appVersion;

        return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    },

    /* 微信分享 */
    wechatjs: {
        is_first: true,
        setShareUrl: function(_url) {
            if (app.wechatjs.share_config) {
                app.wechatjs.share_config.share_url = _url;
            } else {
                app.wechatjs.share_config = {
                    share_url: _url
                };
            }
        },
        run: function(obj) {
            var data = {
                url: obj.api_url,
                ajax_data: obj.ajax_data || {},
                api_url: obj.api_url || '/',
                api_type: obj.api_type || 'POST',
                api_list: obj.api_list || [],
                hide_menu_items: obj.hide_menu_items || [],
                show_menu_items: obj.show_menu_items || [],
                debug: obj.debug || false
            };

            // data.ajax_data['url'] = location.href.split('#')[0];

            data.api_list.push('hideMenuItems');
            data.api_list.push('showMenuItems');

            //默认为分享朋友圈和好友
            data.api_list.push('onMenuShareTimeline');
            data.api_list.push('onMenuShareAppMessage');

            // 获取网络状态
            data.api_list.push('getNetworkType');
            // 获取扫码权限
            data.api_list.push('scanQRCode');

            //微信js配置
            app.wechatjs.config = app.wechatjs.config || false;
            app.wechatjs.share_config = app.wechatjs.share_config || false;
            if (app.wechatjs.config === false) {
                //debugger
                if (app.device().ios) {
                    data.ajax_data['url'] = tools.cache.get('initUrl');
                } else {
                    data.ajax_data['url'] = location.href;
                }
                //获取js签名
                tools.ajax({
                    url: data.api_url,
                    ajaxData: data.ajax_data,
                    type: data.api_type,
                    successFun: function(res) {
                        //originUrl记录第一次的分享链接，ios 特殊页面跳回来的时候用到
                        if (app.wechatjs.is_first) {
                            //console.log(`app : ${res.data.share_url}`);
                            tools.cache.set('originUrl', res.data.share_url);
                            app.wechatjs.is_first = false;
                        }
                        if (app.wechatjs.share_config && app.wechatjs.share_config.is_specific) {

                        } else {
                            app.wechatjs.setShareUrl(res.data.share_url);
                        }
                        /*app.wechatjs.setShareUrl(res.data.share_url);*/
                        /*if(!/^\/distribution\/testgoods\/goodsdetail/i.test(tools.router.currentRoute.fullPath)){
                            app.wechatjs.setShareUrl(res.data.share_url);
                        }
                        else{
                            app.wechatjs.setShareUrl(location.origin + tools.router.currentRoute.fullPath.replace(/^\/distribution\/testgoods/i,'/retail/testgoods'));
                        }*/
                        //全局配置
                        app.wechatjs.config = {
                            debug: data.debug,
                            appId: res.data.sign.appId,
                            timestamp: res.data.sign.timestamp,
                            nonceStr: res.data.sign.nonceStr,
                            signature: res.data.sign.signature,
                            jsApiList: data.api_list
                        };
                        //alert(JSON.stringify(app.wechatjs.config))
                        //alert(app.wechatjs.share_config.share_url);

                        wx.config(app.wechatjs.config);

                        wx.ready(function() {
                            //alert(location.href.split('#')[0])
                            if (app.wechatjs.share_config !== false) {
                                //alert(JSON.stringify(app.wechatjs.share_config))
                                // 分享到朋友圈
                                wx.onMenuShareTimeline({
                                    desc: app.wechatjs.share_config.share_desc || '全生命周期的健康管理', // 分享描述
                                    title: app.wechatjs.share_config.share_title || '生命说商城', // 分享标题
                                    link: app.wechatjs.share_config.share_url || res.data.share_url, // 分享链接
                                    imgUrl: app.wechatjs.share_config.share_img || location.origin + '/static/images/mainproduct.jpg?123', // 分享图标
                                    success: function() {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function() {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });
                                //alert(app.wechatjs.share_config.share_url || res.data.share_url);
                                // 分享给朋友
                                wx.onMenuShareAppMessage({
                                    desc: app.wechatjs.share_config.share_desc || '全生命周期的健康管理', // 分享描述
                                    title: app.wechatjs.share_config.share_title || '生命说商城', // 分享标题
                                    link: app.wechatjs.share_config.share_url || res.data.share_url, // 分享链接
                                    imgUrl: app.wechatjs.share_config.share_img || location.origin + '/static/images/mainproduct.jpg?123', // 分享图标
                                    type: 'link', // 分享类型,music、video或link，不填默认为link
                                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                                    success: function() {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function() {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });
                                if (obj.hideAllNonBaseMenuItem) {
                                    wx.hideAllNonBaseMenuItem();
                                }
                                wx.hideMenuItems({
                                    menuList: data.hide_menu_items // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
                                });

                                wx.showMenuItems({
                                    menuList: data.show_menu_items // 要显示的菜单项
                                });
                            }

                            if (app.isWeChat()) {
                                (function() {
                                    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
                                        handleFontSize();
                                    } else {
                                        if (document.addEventListener) {
                                            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
                                        } else if (document.attachEvent) {
                                            document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                                            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
                                        }
                                    }

                                    function handleFontSize() {
                                        // 设置网页字体为默认大小
                                        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
                                        // 重写设置网页字体大小的事件
                                        WeixinJSBridge.on('menu:setfont', function() {
                                            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
                                        });
                                    }
                                })();
                            }

                        });
                        wx.error(function(res) {
                            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                        });

                    }
                });
            }
        },
        ready: function(obj) {
            if (app.wechatjs.config !== false) {
                wx.ready(function() {
                    //debugger
                    //alert(app.wechatjs.share_config.share_url)
                    if (app.wechatjs.share_config !== false) {
                        // 分享到朋友圈
                        wx.onMenuShareTimeline({
                            title: obj.share_title || '生命说商城', // 分享标题
                            link: obj.share_url, // 分享链接
                            desc: obj.share_desc || '全生命周期的健康管理', // 分享描述
                            imgUrl: obj.share_img || app.defaultImg(), // 分享图标
                            success: function() {
                                // 用户确认分享后执行的回调函数
                            },
                            cancel: function() {
                                // 用户取消分享后执行的回调函数
                            }
                        });
                        // 分享给朋友
                        wx.onMenuShareAppMessage({
                            title: obj.share_title || '生命说商城', // 分享标题
                            desc: obj.share_desc || '全生命周期的健康管理', // 分享描述
                            link: obj.share_url, // 分享链接
                            imgUrl: obj.share_img || app.defaultImg(), // 分享图标
                            type: 'link', // 分享类型,music、video或link，不填默认为link
                            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                            success: function() {
                                // 用户确认分享后执行的回调函数
                            },
                            cancel: function() {
                                // 用户取消分享后执行的回调函数
                            }
                        });
                    }
                });
                wx.error(function(res) {
                    tools.alert.error(res);
                    // location.href = location.href;
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                });

            }
        }
    },

    /* 判断网络状态 */
    netWorkType: function(params) {
        let netWorkType = '';
        
        wx.getNetworkType({
            success: function(res) {
                netWorkType = res.networkType;
                return netWorkType;
            }
        })
    },

    /* 扫码 */
    scanQRCode: function(params,cb) {
        let param = params || {};
        wx.scanQRCode({
            needResult: param.needResult || 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: param.scanType || ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
              var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              if (typeof params == "function") {
                params(result);
              }else{
                cb(result)
              }
            }
          });
          
          
    },

    /* 克隆对象 */
    extend: function(origin) {
        let originProto = Object.getPrototypeOf(origin);
        return Object.assign(Object.create(originProto), origin);
    },

    seeImg: function(curSrc, srcList) {
        if (!curSrc || !srcList || srcList.length == 0) {
            return;
        }

        if (this.isWeChat()) {
            wx.previewImage({
                'current': curSrc,
                'urls': srcList
            });
        } else {

        }

    },

    /* 是否数组 */
    isArray: function isArray(args) {
        return Object.prototype.toString.call(args) === "[object Array]"
    }
}


// WEBPACK FOOTER //
// ./src/common/app.js